import React, { FC } from 'react';
import { Container } from '@src/components/Container';
import './styles.scss';

export const Skeleton: FC = () => {
  return (
    <Container className="opening-applicant-card-skeleton opening-applicant-card-skeleton--wrapper pulse-fade">
      <div className="opening-applicant-card-skeleton__avatar" />

      <div className="opening-applicant-card-skeleton__right-section">
        <div className="opening-applicant-card-skeleton__bar opening-applicant-card-skeleton__bar--m" />

        <div className="opening-applicant-card-skeleton__bar opening-applicant-card-skeleton__bar--s" />

        <div className="opening-applicant-card-skeleton__middle-part">
          <div className="opening-applicant-card-skeleton__middle-part-section">
            <div className="opening-applicant-card-skeleton__bar" />

            <div className="opening-applicant-card-skeleton__bar opening-applicant-card-skeleton__bar--xl" />

            <div className="opening-applicant-card-skeleton__bar opening-applicant-card-skeleton__bar--xxxl" />
          </div>

          <div className="opening-applicant-card-skeleton__middle-part-section">
            <div className="opening-applicant-card-skeleton__bar opening-applicant-card-skeleton__bar--xl" />

            <div className="opening-applicant-card-skeleton__circles">
              <div className="opening-applicant-card-skeleton__avatar-small" />

              <div className="opening-applicant-card-skeleton__avatar-small" />

              <div className="opening-applicant-card-skeleton__avatar-small" />
            </div>
          </div>

          <div className="opening-applicant-card-skeleton__middle-part-section">
            <div className="opening-applicant-card-skeleton__bar opening-applicant-card-skeleton__bar--m" />

            <div className="opening-applicant-card-skeleton__bar opening-applicant-card-skeleton__bar--xl" />
          </div>
        </div>
      </div>
    </Container>
  );
};
